module.exports = __webpack_public_path__ + "img/righticon.bc28ffc1.png";